import React from 'react';
import { CheckIcon } from 'lucide-react';
export function SolutionSection() {
  const features = ['Mandatsannahme', 'Aktenanlage & Datenerfassung', 'Strukturierte Mandantenkommunikation', 'Automatische Dokumentenerstellung', 'Erstschreiben & Korrespondenz', 'Fristenüberwachung', 'Prozessdokumentation', 'Übergabe an RA-Micro, AnNoText, DATEV etc.'];
  return <section className="py-20 bg-blue-50" data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-185">
          <h2 id="solution" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-id="element-186">
            Die Lösung
          </h2>
          <h3 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-187">
            Legallama automatisiert Ihre verkehrsrechtlichen Mandatsprozesse –
            von der Annahme bis zur rechtskräftigen Entscheidung
          </h3>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-188">
          <div className="bg-white rounded-xl p-8 shadow-lg mb-8" data-id="element-189">
            <p className="text-lg text-gray-700 mb-6" data-id="element-190">
              LegalLama ist eine spezialisierte Automatisierungsplattform für
              Fachanwälte im Verkehrsrecht. Alle Prozesse, die sich wiederholen,
              werden von unserer KI und Workflow-Engine übernommen – ohne
              Änderungen an Ihrer Kanzleisoftware und ohne IT-Aufwand.
            </p>
            <h4 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-191">
              Automatisiert werden u. a.:
            </h4>
            <div className="grid sm:grid-cols-2 gap-3" data-id="element-192">
              {features.map((feature, index) => <div key={index} className="flex items-start gap-3" data-id="element-193">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-194" />
                  <span className="text-gray-700" data-id="element-195">{feature}</span>
                </div>)}
            </div>
          </div>
          <div className="border border-red-300 bg-red-50 rounded-xl p-8 text-center" data-id="element-196">
            <p className="text-lg font-semibold text-gray-900" data-id="element-197">
              Von 30 Minuten manueller Arbeit auf 30 Sekunden
              vollautomatisierten Ablauf.
            </p>
          </div>
        </div>
      </div>
    </section>;
}